var SpriteSymbol = require("../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "charging_station",
  "use": "charging_station-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"charging_station\"><g id=\"charging_station_Layer_1_1_\"><path d=\"M38.618,20H26V0.764L11.382,30H24v19.236L38.618,20z M14.618,28L24,9.236V22h11.382L26,40.764V28H14.618z\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id